import {
  GET_DATE_FORMAT,
  GET_DATE_FORMAT_FAILURE,
  GET_DATE_FORMAT_SUCCESS,
  UPDATE_DATE_FORMAT,
  UPDATE_DATE_FORMAT_FAILURE,
  UPDATE_DATE_FORMAT_SUCCESS,
  UPDATE_START_WEEK_DAY,
  UPDATE_START_WEEK_DAY_SUCCESS,
  UPDATE_START_WEEK_DAY_FAILURE,
} from "../../../modules/constants";

import { createNotification } from "../../../modules/notificationManager";

const updateStartDayOfWeekHandler = (state, action) => {
  return {
    ...state,
    isLoading: false,
  };
};

const updateStartDayOfWeekSuccessHandler = (state, action) => {
  const {
    payload: { data },
  } = action;
  createNotification("success", "Start day of week updated.", 2000);
  const startDay = data?.data?.start_day_of_week
  localStorage.setItem("start_day_of_week", startDay);

  return {
    ...state,
    isLoading: false,
    isDateFormatUpdated: true,
    startDayOfWeek: data.data.start_day_of_week,
  };
};

const updateStartDayOfWeekFailureHandler = (state, action) => {
  createNotification("error", "Something went wrong!! Please try again.", 2000);
  return {
    ...state,
    isLoading: false,
  };
};

const getDateFormatHandler = (state, action) => {
  return {
    ...state,
    isLoading: true,
  };
};

const getDateFormatSuccessHandler = (state, action) => {
  const {
    payload: { data },
  } = action;

  if (data?.data?.start_day_of_week) {
    localStorage.setItem("start_day_of_week", data.data.start_day_of_week);
  }

  return {
    ...state,
    isLoading: false,
    isDateFormatUpdated: true,
    dateFormat: data.data.date_format,
    startDayOfWeek: data.data.start_day_of_week,
  };
};

const getDateFormatFailureHandler = (state, action) => {
  return {
    ...state,
    isLoading: false,
    dateFormat: null,
  };
};

const updateDateFormatHandler = (state, action) => {
  return {
    ...state,
    isLoading: false,
  };
};

const updateDateFormatSuccessHandler = (state, action) => {
  const {
    payload: { data },
  } = action;

  createNotification("success", "Date format updated.", 2000);
   data?.data?.date_format &&
    localStorage.setItem("date_format", data.data.date_format);
  return {
    ...state,
    isLoading: false,
    isDateFormatUpdated: true,
    dateFormat: data.data.date_format,
  };
};

const updateDateFormatFailureHandler = (state, action) => {
  createNotification("error", "Something went wrong!! Please try again.", 2000);

  return {
    ...state,
    isLoading: false,
    dateFormat: null,
  };
};

const ACTION_HANDLERS = {
  [GET_DATE_FORMAT]: getDateFormatHandler,
  [GET_DATE_FORMAT_SUCCESS]: getDateFormatSuccessHandler,
  [GET_DATE_FORMAT_FAILURE]: getDateFormatFailureHandler,

  [UPDATE_DATE_FORMAT]: updateDateFormatHandler,
  [UPDATE_DATE_FORMAT_SUCCESS]: updateDateFormatSuccessHandler,
  [UPDATE_DATE_FORMAT_FAILURE]: updateDateFormatFailureHandler,
  
  [UPDATE_START_WEEK_DAY]: updateStartDayOfWeekHandler,
  [UPDATE_START_WEEK_DAY_SUCCESS]: updateStartDayOfWeekSuccessHandler,
  [UPDATE_START_WEEK_DAY_FAILURE]: updateStartDayOfWeekFailureHandler,
};

const initialState = {
  isLoading: false,
  dateFormat: null,
  isDateFormatUpdated: false,
  startDayOfWeek: null,
};

export default function dateTimeSettingsReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
